'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'face-thinking';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e39b';
var svgPathData = ['M48 256c0-48.2 16.4-92.7 44-127.9 0 3.4 .9 6.8 2.6 9.9 5.5 9.6 17.7 12.9 27.3 7.4l13.1-7.5c19.7-11.3 44.1-10.4 63.1 2.2l30.9 20.6c9.2 6.1 21.6 3.6 27.7-5.5s3.6-21.6-5.5-27.7l-30.9-20.6c-31.5-21-72.2-22.4-105.1-3.6l-.6 .4c37.1-34.5 86.8-55.5 141.5-55.5 114.9 0 208 93.1 208 208 0 98.6-68.6 181.2-160.7 202.6 .5-3.5 .7-7 .7-10.6 0-44.2-35.8-80-80-80l-113.6 0c-5.9-29.2-27.8-52.6-56.1-60.8-4.1-16.4-6.3-33.5-6.3-51.2zm96-48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm2 120c0 13.3 10.7 24 24 24l110 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-110 0c-13.3 0-24 10.7-24 24zM304 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z', 'M303.3 458.6c92.1-21.4 160.7-104 160.7-202.6 0-114.9-93.1-208-208-208-54.6 0-104.4 21.1-141.5 55.5l.6-.4c32.9-18.8 73.6-17.4 105.1 3.6l30.9 20.6c9.2 6.1 11.7 18.5 5.5 27.7s-18.5 11.7-27.7 5.5L198 140.1c-18.9-12.6-43.3-13.4-63.1-2.2l-13.1 7.5c-9.6 5.5-21.8 2.1-27.3-7.4-1.8-3.1-2.6-6.5-2.6-9.9-27.6 35.3-44 79.7-44 127.9 0 17.7 2.2 34.8 6.3 51.2-7.1-2.1-14.6-3.2-22.3-3.2-9.3 0-18.3 1.6-26.6 4.5-3.5-17-5.4-34.5-5.4-52.5 0-141.4 114.6-256 256-256S512 114.6 512 256c0 135.8-105.7 246.9-239.3 255.5 16.4-12.6 27.7-31.4 30.6-52.9zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM146 328c0-13.3 10.7-24 24-24l110 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-110 0c-13.3 0-24-10.7-24-24zM64 384l0 32 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0 0 24c0 39.8-32.2 72-72 72l-32 0c-39.8 0-72-32.2-72-72L0 384c0-17.7 14.3-32 32-32s32 14.3 32 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceThinking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;